import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { useThemeProps } from "@mui/material";
import { forwardRef } from "react";
import { useSlotProps } from "../../base/index.js";
import { highlighterName } from "./classes.js";
import { Root } from "./components/Root.js";
import { Token } from "./components/Token.js";
import { useTokens } from "./hooks/useTokens.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const Highlighter = forwardRef(function Highlighter2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: highlighterName
  });
  const {
    text,
    pattern,
    components,
    caseSensitive,
    componentsProps,
    testId = `${highlighterName}-Root`,
    ...rest
  } = props;
  const ownerState = { ...props };
  const tokens = useTokens(text, pattern, caseSensitive);
  const utilityClasses = useUtilityClasses(ownerState);
  const rootSlotProps = useSlotProps({
    ownerState,
    externalForwardedProps: rest,
    className: utilityClasses.root,
    elementType: Root,
    externalSlotProps: componentsProps?.root,
    additionalProps: {
      as: components?.Root,
      "data-testid": testId,
      "data-original-text": text,
      ref
    }
  });
  return /* @__PURE__ */ jsx(Root, { ...rootSlotProps, "data-tidal": "Highlighter", children: tokens.map((token, key) => /* @__PURE__ */ createElement(Token, { ...token, classes: utilityClasses, key })) });
});
export {
  Highlighter
};
//# sourceMappingURL=Highlighter.js.map
